export const ensureUrlHasScheme = (href?: string | null): string => {
  if (!href) return '';

  const trimmed = href.trim();
  if (!trimmed) return '';

  // Preserve anchor links and relative URLs
  if (trimmed.startsWith('#') || trimmed.startsWith('/')) return trimmed;

  const hasSchemeRegex = /^[a-zA-Z][a-zA-Z0-9+.-]*:/;

  return hasSchemeRegex.test(trimmed) ? trimmed : `https://${trimmed}`;
};
